const $window = $(window);
let windowWidth = $window.width();

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

//preload
import {preload} from "../include/module";
preload();

// toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {

  // setTimeout(function(){$('#st-Loader .st-Loader_Logo').addClass("load");},400);
  // setTimeout(function(){$('#st-Loader').addClass("hidden");},1200);
  // setTimeout(function(){$('#st-Loader').remove();},1600);

  // setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},1600);

  scrollSpecialAnime();

});



// ------------------------------------------------------------------------
// scrollSpecialAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollSpecialAnime = () => {

  const controller = new ScrollMagic.Controller();
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  // //シーンを作成
  // const scene = new ScrollMagic.Scene({
  //     triggerElement: target,
  //     triggerHook: .8
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-News',
    triggerHook: 1,
    offset: '80'
  })
  // .setClassToggle('#st-Top', 'st-Top-Show')
  .setClassToggle('#st-Top', 'hidden')
  .addTo(controller);


  //バンド背景
  // const scene2 = new ScrollMagic.Scene({
  //   triggerElement:'#index-Afterglow',
  //   triggerHook: 1,
  //   offset: '0'
  // })
  // .setClassToggle('#index-Bg', 'afterglow')
  // .addTo(controller);



  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .8
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};



// WEBPACK FOOTER //
// ./src/assets/js/special/script.js